/**
 * The app shell's chat affordances (the desktop launcher, the mobile Chat
 * tab) only flip the chat panel's visibility — they do not know whether the
 * outreach on screen already has an agent run behind it. The outreach detail
 * page does, so the shell announces the open and the page claims a runner
 * when one is missing.
 *
 * The name lives here rather than in either component so the two sides
 * cannot drift apart silently.
 */
export const OPEN_OUTREACH_CHAT_EVENT = 'phoebe:open-outreach-chat';

export type OutreachChatOpenedDetail = {
    readonly outreachId: string;
};

export function announceOutreachChatOpened(outreachId: string | null): void {
    if (!outreachId || typeof window === 'undefined') {
        return;
    }
    window.dispatchEvent(
        new CustomEvent<OutreachChatOpenedDetail>(OPEN_OUTREACH_CHAT_EVENT, {
            detail: { outreachId },
        }),
    );
}
